import { isEqual } from 'lodash';
import { IFilterComparator } from '../../filter-types';
import { FirstCallFilterModel } from '../../../../grid/components/filters/first-call-filter/first-call-filter.component';

export class FirstCallFilterModelComparator
  implements IFilterComparator<FirstCallFilterModel> {
  applyFilterOptions() {
    // do nothing
  }

  hasValidDiff(
    grid: Partial<FirstCallFilterModel>,
    store: FirstCallFilterModel
  ): boolean {
    if (!grid) {
      return true;
    }
    if (
      isEqual(grid.minValue, store.minValue) &&
      isEqual(grid.maxValue, store.maxValue) &&
      isEqual(grid.isFilterActive, store.isFilterActive) &&
      isEqual(grid.radio, store.radio)
    ) {
      return false;
    }

    return true;
  }
}
